var _a;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@/inversify.config';
import { KeywordSearchApi } from './apis/keyword-search-api.interface';
let KeywordSearchRepositoryImpl = class KeywordSearchRepositoryImpl {
    constructor(_keywordSearchApi) {
        this._keywordSearchApi = _keywordSearchApi;
    }
    async getKeywordSuggest(keyword) {
        const res = await this._keywordSearchApi.getKeywordSuggest(keyword);
        const result = res.map((item) => {
            return {
                input: item.input,
                keywordList: item.keyword_list,
            };
        });
        return result;
    }
};
KeywordSearchRepositoryImpl = __decorate([
    injectable(),
    __param(0, inject(KeywordSearchApi)),
    __metadata("design:paramtypes", [typeof (_a = typeof KeywordSearchApi !== "undefined" && KeywordSearchApi) === "function" ? _a : Object])
], KeywordSearchRepositoryImpl);
export { KeywordSearchRepositoryImpl };
